<script>
import MasterRoomOfferBenefits from '@components/master-room-offer-benefits'
import MasterRoomOfferOccupancy from '@components/master-room-offer-occupancy'
import MasterRoomOfferPrice from '@components/master-room-offer-price'
import MasterRoomOfferRooms from '@components/master-room-offer-rooms'

export default {
  components: {
    MasterRoomOfferBenefits,
    MasterRoomOfferOccupancy,
    MasterRoomOfferPrice,
    MasterRoomOfferRooms,
  },
  props: {
    room: { type: Object, required: true },
    roomIndex: { type: Number, default: 0 },
  },
  data() {
    return {
      expanded: this.roomIndex === 0,
    }
  },
  computed: {
    offerClass() {
      return {
        hidden: this.room.ratePlans.length > 1,
      }
    },
  },
}
</script>

<template>
  <div class="w-full md:w-9/12 px-3">
    <div class="hidden md:flex my-3 text-sm font-medium">
      <div class="w-4/12">Inclusion</div>
      <div class="w-2/12">Occupancy</div>
      <div class="w-4/12">Price</div>
      <div class="w-2/12">Rooms</div>
    </div>
    <div class="flex flex-wrap">
      <div
        v-for="(ratePlan, index) in room.ratePlans"
        :key="ratePlan.id"
        class="md:block w-full bg-white mb-3"
        :class="{ hidden: !expanded }"
      >
        <div
          class="flex flex-wrap"
          :class="[
            index === 0 && room.ratePlans.length > 1
              ? 'border-2 border-orange-500'
              : 'border border-gray-400',
          ]"
        >
          <MasterRoomOfferBenefits
            class="w-full md:w-4/12 md:border-r border-gray-400"
            :rate-plan="ratePlan"
            :room="room"
            :index="index"
          />
          <MasterRoomOfferOccupancy
            class="w-1/2 md:w-2/12 md:border-r border-gray-400"
            :rate-plan="ratePlan"
            :room="room"
          />
          <MasterRoomOfferPrice
            class="w-1/2 md:w-4/12 md:border-r border-gray-400"
            :rate-plan="ratePlan"
            :room="room"
          />
          <MasterRoomOfferRooms
            class="w-full md:w-2/12"
            :rate-plan="ratePlan"
            :room="room"
          />
        </div>
      </div>
      <!-- room offer -->
      <a
        class="block md:hidden w-full py-3 font-medium text-blue-500 text-center cursor-pointer"
        @click="expanded = !expanded"
      >
        {{ expanded ? 'Show less' : 'Show more' }}
        <i
          class="fas"
          :class="expanded ? 'fa-chevron-up' : 'fa-chevron-down'"
        ></i>
      </a>
    </div>
  </div>
</template>
